import { render, staticRenderFns } from "./Selfinfo.vue?vue&type=template&id=8f716190"
import script from "./Selfinfo.vue?vue&type=script&lang=js"
export * from "./Selfinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports